document.addEventListener("DOMContentLoaded", function () {
  // Hide tooltip when a variant label is clicked, if it's not already hidden
  document.querySelectorAll(".variants__picker label").forEach(function (label) {
    label.addEventListener("click", function () {
      var tooltip = document.querySelector(".variants__picker .tooltip");
      if (tooltip && !tooltip.classList.contains("hidden")) {
        tooltip.classList.add("hidden");
      }
    });
  });

  // Show tooltip if the submit button is disabled when product form buttons are clicked
  document.querySelectorAll(".product-form__buttons").forEach(function (btn) {
    btn.addEventListener("click", function () {
      var submitBtn = document.querySelector(".product-form__submit");
      var tooltip = document.querySelector(".variants__picker .tooltip");
      if (submitBtn && submitBtn.disabled && tooltip) {
        tooltip.classList.remove("hidden");
      }
    });
  });
});
